module.exports = __webpack_public_path__ + "img/icon-warning.7934890d.svg";